import { useSearchParams } from 'react-router-dom';
import { ResetPassword } from '../../features/ResetPassword/ui/ResetPassword/ResetPassword';
import { PageWrapper } from '../../shared/ui/PageWrapper/PageWrapper';
import { useEffect } from 'react';
import { initPage, resetToken } from '../../entities/passwordReset/models/events';
import { useUnit } from 'effector-react';
import { ResetPasswordSkeleton } from '../../features/ResetPassword/ui/ResetPasswordSkeleton/ResetPasswordSkeleton';
import { $isInitializing, $isValidToken } from '../../entities/passwordReset/models/store';
import { ChangePassword } from '../../features/ChangePassword/ui/ChangePassword';
import { InvalidLink } from '../../features/ResetPassword/ui/InvalidLink/InvalidLink';
import { resetFeaturesData } from '../../features/ChangePassword/models/events';


export function ResetPasswordPage() {
    const {
        isInitializing,
        validateStore,
    } = useUnit({
        isInitializing: $isInitializing,
        validateStore: $isValidToken,
    });

    const [searchParams, setSearchParams] = useSearchParams();

    const node = validateStore === null 
        ?   <ResetPassword />
        :   validateStore.is_valid 
                ?   <ChangePassword />
                :   <InvalidLink text={validateStore.detail} />

    useEffect(() => {
        initPage(searchParams);

        return () => {
            resetToken();
            resetFeaturesData();
        }
    }, [searchParams])

    return (
        <PageWrapper
            title='Восстановление пароля'
            subText='Восстановите пароль, чтобы снова войти в систему'
        >
            {
                isInitializing
                    ?   node
                    :   <ResetPasswordSkeleton />
            }
        </PageWrapper>
    )
}
